import { Redirect, Route, Switch, useRouteMatch } from "react-router";

import AccessManagerPage from "features/panelManagement/accessManagement/screens/access";
import { Roles } from "features/panelManagement/accessManagement/types/access";
import LoggingPage from "features/panelManagement/logging/screens";
import PrivateRoute from "features/routing/components/privateRoute";
import { useEffect, useMemo } from "react";
import withAdminNavbar from "features/navbar/wrappers/withAdminNavbar";
import BackupsPage from "features/panelManagement/backups/screens";
import { useDispatch } from "services/redux/rootReducer";
import getAllBackups from "features/panelManagement/backups/actions/backup.getAllBackups";

const PanelManagementPage = () => {
    const { path } = useRouteMatch();
    const dispatch = useDispatch();

    const defaultDisplay = useMemo(() => {
        return <Redirect to="content-edit/tag" />;
    }, []);

    useEffect(() => {
        let unsubscribers: Array<() => void> = [];

        unsubscribers.push(dispatch(getAllBackups()));

        return () => {
            unsubscribers.forEach((unsubscriberFn) => unsubscriberFn());
        };
    }, [dispatch]);

    return withAdminNavbar(
        <Switch>
            <Route exact path={path}>
                {defaultDisplay}
            </Route>
            <PrivateRoute
                roles={[Roles.OWNER]}
                exact
                path={`${path}/manage-access`}
                withNavbar={false}
            >
                <AccessManagerPage />
            </PrivateRoute>
            <PrivateRoute
                roles={[Roles.OWNER]}
                exact
                path={`${path}/logs`}
                withNavbar={false}
            >
                <LoggingPage />
            </PrivateRoute>
            <PrivateRoute
                roles={[Roles.ADMIN, Roles.OWNER]}
                exact
                path={`${path}/backups`}
                withNavbar={false}
            >
                <BackupsPage />
            </PrivateRoute>
        </Switch>
    );
};

export default PanelManagementPage;
